import { __rest } from "tslib";
import React, { Component } from 'react';
import styled from 'styled-components';
import { fontEndConfig } from '@/shared/utils';
const noValueReplace = fontEndConfig.noValueReplace;
const Root = styled.div `
  .text {
    font-size: 12px;
    color: ${(props) => props.textColor || '#666'};
    ${(props) => props.textStyle};
  }
  .number {
    margin-top: 5px;
    font-size: 24px;
    color: ${(props) => props.numberColor || '#1a1a1a'};
    ${(props) => props.numberStyle};
  }
  .number.link {
    color: ${(props) => props.numberLinkColor || '#0080ff'};
    cursor: pointer;
    ${(props) => props.numberLinkStyle};
  }

`;
class ColumnTextNum extends Component {
    render() {
        const _a = this.props, { text = noValueReplace, number = noValueReplace, style = {}, className = '', onClick } = _a, restProps = __rest(_a, ["text", "number", "style", "className", "onClick"]);
        return (<Root style={style} className={`${className} flex__column-btS`} {...restProps}>
        <div className="text">{text}</div>
        <div className={`number ${onClick ? 'link' : ''}`} onClick={onClick}>
          {number}
        </div>
      </Root>);
    }
}
export default ColumnTextNum;
